import { createContext } from 'react';
const EventEmitterContext = /*#__PURE__*/createContext(null);
export default EventEmitterContext;